import React from 'react';
import StTextField from '../misc/textField';
import StButton from "../misc/button";
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
 
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import './index.css'

const SignUpPage = () => (
    <div>
        <SignUpForm />
    </div>
  );

    const INITIAL_STATE = { email: '', passwordOne: '', passwordTwo: '', name: '' };

class SignUpFormBase extends React.Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;

        this.handleSignup = this.handleSignup.bind(this)
        this.onEmailChange = this.onEmailChange.bind(this)
        this.onNameChange = this.onNameChange.bind(this)
        this.onPasswordOneChange = this.onPasswordOneChange.bind(this)
        this.onPasswordTwoChange = this.onPasswordTwoChange.bind(this)
    }

    handleSignup() {
        console.log(this.state)
        const {name, email, passwordOne} = this.state;

        this.props.firebase
        .doCreateUserWithEmailAndPassword(name, email, passwordOne)
        .then(authUser => {
          this.setState({ ...INITIAL_STATE });
          this.props.history.push(ROUTES.HOME);
        })
        .catch(error => {
            //alert(error);
            this.setState({ error: error.toString() });
        });

    }

    onEmailChange(newString) {
        this.setState(state => ({
            email: newString
        }));
    }

    onNameChange(newString) {
        this.setState(state => ({
            name: newString
        }));
    }

    onPasswordOneChange(newString) {
        this.setState(state => ({
            passwordOne: newString
        }));
    }

    onPasswordTwoChange(newString) {
        this.setState(state => ({
            passwordTwo: newString
        }));
    }

    render() {
        const isInvalid =
        this.state.passwordOne !== this.state.passwordTwo ||
        this.state.passwordOne === '' ||
        this.state.email === '' || this.state.name === '';
        return (
            <div className="App">
                <header className="App-header">
                    <div className="banner">
                        <img alt="" src={require('./../../assets/stBanner.png')} className="bannerImage" />
                        <div className="bannerText" > builder </div>
                    </div>
                    <form >
                        <StTextField id="name" label="Name" onChange={this.onNameChange} />
                        <br />
                        <br />
                        <StTextField id="login" label="Email" onChange={this.onEmailChange} />
                        <br />
                        <br />
                        <StTextField id="password1" type="password" label="Password" onChange={this.onPasswordOneChange} />
                        <br />
                        <br />
                        <StTextField id="password2" type="password" label="Confirm Password" onChange={this.onPasswordTwoChange} />
                        <br />
                        <br />
                        { (this.state.error) ? <h5 className="error" style={{color: '#f00', backgroundColor: 'yellow'}} >{this.state.error}</h5> : '' }
                        <StButton onClick={this.handleSignup} text={"Sign Up"} isDisabled={isInvalid}></StButton>
                        <br />
                        <br />
                    </form>
                    <br />
                        Already have an account?
                    <br />
                    <br />
                    <StButton href={ROUTES.SIGN_IN} text="Sign In" ></StButton>
                </header>
            </div>

        );
    }
}

const SignUpForm = compose(
    withRouter,
    withFirebase,
  )(SignUpFormBase);

export default SignUpPage;
export { SignUpForm };